<template>
  <div class="left-drawer">
    <div class="hide-on-med-and-down">
      <div v-if="showLeftPanel" class="card z-depth-0">

        <NavigationPanel />
        <div v-if="true" class="divider"></div>
        <favorites />
        <div class="divider"></div>
        <last-seen-articles />
      </div>
    </div>
    <ul id="slide-out-left" class="sidenav sidenav-left">
      <navigation-panel class="sidenav-close" />
      <div class="divider"></div>
      <favorites />
      <div class="divider"></div>
      <last-seen-articles />
      <div class="divider"></div>
      <button class="btn black sidenav-close">
        {{ this.$store.state.user.langEng ? "Close" : "Stäng" }}
      </button>
    </ul>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import Favorites from "./Favorites";
import LastSeenArticles from "./LastSeenArticles";
import NavigationPanel from "./NavigationPanel";

@Component({
  components: {
    Favorites,
    LastSeenArticles,
    NavigationPanel,
  },
})
export default class LeftPanel extends Vue {
  get isAdmin() {
    return this.$store.getters.isAdmin;
  }
  get showLeftPanel() {
    return this.$store.state.drawers.showLeftPanel;
  }
  mounted() {
    let elem = document.querySelector(".left-drawer .sidenav");
    this.$M.Sidenav.init(elem);
  }
}
</script>

<style lang="scss">
.left-drawer {
  padding: 0 0.75em;
  #slide-out {
    padding-top: 15px !important;
  }
  .card {
    border-radius: 5px;
    margin: 1.5em 0 0;
    padding: 1em 1em 2em;
    position: relative;
    .divider {
      margin: 1em 0;
    }
  }
}
.sidenav {
  padding: 1em 1em 0 !important;
  .btn {
    margin: 1em 0 0 ;
    width: 80%;
  }
}

@media (max-width: 992px) {
  .left-drawer {
    width: 0;
  }
}
</style>
